import { omit, pick } from 'lodash-es';
import { RECORDING_SERVICE_BASEURL } from 'config';
import ServiceFactory, { returnVoid } from 'services/ServiceFactory';
import {
  RECORDINGS_PATH,
  RECORDING_PATH,
  RECORDING_DETAIL_PATH,
} from './constants';
import {
  GetRecordingByIdArgs,
  GetRecordingsArgs,
  GetRecordingsResult,
  Recording,
  UpdateRecordingOptions,
} from './types';

const serviceFactory = new ServiceFactory(RECORDING_SERVICE_BASEURL, {
  omitBearerPrefix: true,
});

/**
 * Lists all call recordings with query filters
 */
export const getRecordings = serviceFactory.createGetEndpoint(RECORDINGS_PATH)<
  GetRecordingsArgs,
  GetRecordingsResult
>({
  queryParams: (args) => ({
    published: args.published,
    recordingId: args.recordingIds,
    userId: args.userId,
  }),
});

/**
 * Find a call recording by id
 */
export const getRecordingById = serviceFactory.createGetEndpoint(
  RECORDING_PATH,
)<GetRecordingByIdArgs, Recording>({
  queryParams: (args) => pick(args, 'userId'),
});

/**
 * Update the meta data for a recording
 *
 * This endpoint acts as patch. If a field is missing in the body, it is left untouched.
 * In order to reset or empty a field, you must send it with either null or empty string value.
 */
export const updateRecording = serviceFactory.createPutEndpoint(
  RECORDING_DETAIL_PATH,
)<
  UpdateRecordingOptions,
  void,
  void,
  Omit<UpdateRecordingOptions, 'recordingId'>
>({
  data: (args) => omit(args, 'recordingId'),
  select: returnVoid(),
});
